module.exports = __webpack_public_path__ + "img/hy1.28e7d7a9.png";